import * as Yup from "yup";
import { isDomainName, isUGPhoneNumber } from "../../constants";

const EscoProfileSchema = Yup.object({
  name: Yup.string()
    .required("Name is required")
    .min(3, "Provide atleast 3 characters")
    .max(100, "Name can't be longer than 100 characters"),
  email: Yup.string().email().required("Email is required"),
  phoneNumber: Yup.string()
    .required("Phone number is required")
    .test("is-ug-phone", "Provide a valid Ugandan phone number", (value) =>
      !value || isUGPhoneNumber(value)
    ),

  website: Yup.string()
    .test("is-domain", "Provide a valid domain e.g www.example.com", (value) =>
      !value || isDomainName(value)
    )
    .notRequired(),
  latitude: Yup.number().notRequired(),
  longitude: Yup.number().notRequired(),
  incorporationDate: Yup.date().required("Date of incorporation is required"),
  address: Yup.string().required("Address is required"),
  specialization: Yup.string().required("Specialization is required"),
});
export default EscoProfileSchema;
